// components/ProtectedRoute.js
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  try {
    const decoded = jwtDecode(token);

    // Check expiry — backend sets exp automatically
    if (decoded.exp * 1000 < Date.now()) {
      console.warn("JWT expired");

      localStorage.removeItem("authToken");
      return <Navigate to="/" replace />;
    }

  } catch (err) {
    console.error("Invalid token:", err);
    localStorage.removeItem("authToken");
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
